import React, { Component, Fragment } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { currentWidget, popupOpenClose } from '../../../action/action'
import { setSelectedLocation } from '../../../action/hcommerce';
import { setCustomLocation, setMapSnapshot } from '../../action/hCommerce2';
import { HashRouter, Redirect, Link } from "react-router-dom";
import {CMSPath, CMSPath_HTTP, DEBUG} from '../../../config/constant';
import { customLocationColorConfig } from '../../JS/colorConfig';
import {withTranslation} from "react-i18next";
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';

class CustomLocation extends Component{

    constructor(props){
        super(props);
        this.state = {
            latitude:null,
            longitude:null,
            mapLoading:false,
            loadingError:null,
            showBoundsErrMsg:false,
            goBack:false,
            showMap: false,
            mapOpened: false,
            highAccuracyrequired: true,
            highAccuracyAttemptFailed: false,
            locationAttemptFailed: false,
            toggel: false,
            mapDeliveryImage: "",
            crossClickable : false,
            sliceStartIndex: CMSPath.startsWith('https') ? 8 : 7
        }
        this.defaultMinHeight = null;
        this.marker = null;
        this.getLocationAfterErr = true
        this.polygonCoords = new URLSearchParams(this.props.location.search).get("mapValues");
        // this.imageBase = "data:image/png:base64,atgd"
    }

    getMap = (options=null) => {
        const mapCont = $("#maps_container")[0];
        const map = window.plugin.google.maps.Map.getMap(mapCont, options);
        return map;
    }

    fetchLocation = (highAccuracy=false, successHandler) => {
        
        this.setState({mapLoading:true});

        if (!this.state.mapOpened){
            try {
                window.plugin.google.maps.LocationService.getMyLocation({enableHighAccuracy: highAccuracy},(location) => {
                    this.setState({latitude:location.latLng.lat, longitude:location.latLng.lng, mapLoading:false, loadingError:false})
                    
                    successHandler(location);
                    console.log("location service",location)
                }, this.locationErrHandler);
            } catch (error) {
            this.props.popupOpenClose(true, "Works only in Native Devices.");
            this.setState({showMap: true})
            }
        } else {
            const map = this.getMap()
            map.getMyLocation({enableHighAccuracy: highAccuracy},(location) => {
                
                this.setState({latitude:location.latLng.lat, longitude:location.latLng.lng, mapLoading:false, loadingError:false})
                successHandler(location);
                console.log("location service from map",location)
            }, this.locationWarningHandler);
        }
        
    }

    openSettings = (name="location") => {
        if (window.cordova && window.cordova.plugins.settings) {
            console.log('openNativeSettingsTest is active');
            window.cordova.plugins.settings.open(name, function() {
                    console.log('opened settings');
                    this.setState({goBack:true});
                },
                function () {
                    console.log('failed to open settings');
                }
            );
        } else {
            console.log('openNativeSettingsTest is not active!');
        }
    }

    locationWarningHandler = (err) => {
        
        console.log(`warngin: ${err}`);
        this.setState({loadingError:false, mapLoading: false, highAccuracyAttemptFailed: true});
    }

    locationErrHandler = (err) => {
        if (DEBUG){
            // alert(`${JSON.stringify(err)} - ${err.name} - ${err.message}`);
        } else {
            console.log(err);
        }
        const platform = window.device ? window.device.platform : null;
        if(platform === "Android"){
            this.props.setSelectedLocation(null);
            this.setState({mapLoading:false,loadingError:true, locationAttemptFailed: true})
        }else{
            if(!this.state.mapOpened && this.getLocationAfterErr){
                this.getLocationAfterErr = false
                setTimeout(() => {
                    this.fetchLocation(false, this.openMapsHandler);
                },3000);
            }else{
                this.props.setSelectedLocation(null);
                this.setState({mapLoading:false,loadingError:true, locationAttemptFailed: true})
            }
        }

        let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
        "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), storeName: this.props.storeInfo.storeName, pageName: "MAP",
        "errorMessage": `Unable to fetch location with error: ${err}`}
    
        this.props.sendAnalytics(
            this.props.guestDetail, 
            this.props.currentWidgets.widgetType, 
            "MAP - ERROR", 
            label,
            0, 
            this.props.guestIsLoggedIn,
            () => {}
        );
        
       
    }

    updateMapHandler = (location) => {

        if(this.marker){
            try {
                this.marker.setPosition(location.latLng);
                this.setState({highAccuracyrequired: false, highAccuracyAttemptFailed: false});    
            } catch (error) {
                if (DEBUG){
                    alert(`error on updating marker position: ${error.name} - ${error.message} - ${error}`);
                }
                console.log(`error on updating marker position: ${error.name} - ${error.message} - ${error}`);
            }
            
        } else {
            if (DEBUG){
                alert('Marker not found. Delaying the highAccuracy position update.');
            }
            console.log('Marker not found. Delaying the highAccuracy position update.')
        }
        
    }


    convertMapValues = (mapValues) => {

        if(!mapValues || mapValues.length === 0){
            return;
        }

        let arr = [];

        mapValues.map(el => {
            arr.push({
                "lat":el.latitude,
                "lng":el.longitude
            })
        })

        // const jsonMapValues = JSON.stringify(arr);

        // return jsonMapValues ? jsonMapValues : null;

        return arr || null;
    }

    openMapsHandler = (location) => {

        console.log("fetch location success",location);

        const position = {"lat": location.latLng.lat, "lng": location.latLng.lng}
        // const position = {"lat": 27.709301, "lng": -82.738497}

        /*const polygon_points = [
            {lat: position.lat + 0.00016249,lng:position.lng + 0.00022291},
            {lat: position.lat + 0.00026037,lng:position.lng - 0.00027324},
            {lat: position.lat - 0.00012207,lng:position.lng - 0.000312},
            {lat: position.lat - 0.00027085,lng:position.lng + 0.0003649},
            // {lat: position.lat - 0.0005537,lng:position.lng + 0.00036339},
            
        ];*/

        console.log("this.state.mapDeliveryImage",this.state.mapDeliveryImage)

        const polygon_points = JSON.parse(this.polygonCoords);
        console.log("polygon points",polygon_points);

        const latLngBounds = new window.plugin.google.maps.LatLngBounds(polygon_points);

        const options = {
            mapType: window.plugin.google.maps.MapTypeId.SATELLITE,
            controls: {
                compass: true,
                'myLocationButton': false,
                'myLocation': false
            },
            camera: {
                "latLng": position,
                "zoom": 19
            }
          };

        const map = this.getMap(options);
        
        let self = this;
        map.one(window.plugin.google.maps.event.MAP_READY, (map) => {

            console.log("MAP READY event called");

            window.plugin.google.maps.environment.setBackgroundColor("white");

            map.clear();

            console.log("self.state.mapDeliveryImage",self.state.mapDeliveryImage)
            console.log("self.props.selectedLocation.startPoint",self.props.selectedLocation.startPoint)
            console.log("self.props.selectedLocation.startPoint converted",self.convertMapValues(self.props.selectedLocation.startPoint))
            console.log("self.props.selectedLocation.rotationAngle",self.props.selectedLocation.rotationAngle)

            const polygon = map.addPolygon({
                'points': polygon_points,
                'strokeColor' : 'red',
                'strokeWidth': 2,
                "fillColor":"rgba(255,0,0,0.2)",
                'zIndex': 2
                });

            self.marker = map.addMarker({
                'position': position,
                'title': "Current location",
                "draggable":false
            },(marker) => {
                marker.showInfoWindow();
            });

            if(self.state.mapDeliveryImage){
                const groundOverlay = map.addGroundOverlay({
                    'url': self.state.mapDeliveryImage,
                    'bounds': self.convertMapValues(self.props.selectedLocation.startPoint) || polygon_points,
                    'opacity': 1,
                    'clickable': false,
                    'bearing': self.props.selectedLocation.rotationAngle || 0,
                    });
            }
            
                
            /*map.animateCamera({
                target: latLngBounds,
                duration: 2000,
                zoom:19
            },() => {
                self.marker.showInfoWindow();
            });*/


            /*self.marker.on(window.plugin.google.maps.event.MARKER_DRAG_END,(latlng) => {
                this.setState({latitude:latlng.lat,longitude:latlng.lng});
            })*/

            /*self.marker.on(window.plugin.google.maps.event.MARKER_DRAG,(latlng) => {
                
                if(!latLngBounds.contains(latlng)){
                    this.setState({showBoundsErrMsg:true});
                }else{
                    this.setState({showBoundsErrMsg:false});
                }

                
            })*/
            if(!latLngBounds.contains(position)){
                this.setState({showBoundsErrMsg:true});
            }else{
                this.setState({showBoundsErrMsg:false});
                // this.setState({latitude:position.lat,longitude:position.lng})
            }

            self.setState({mapOpened: true, locationAttemptFailed: false});
        });

        map.on(window.plugin.google.maps.event.MAP_LONG_CLICK, function(latLng) {

            if(!latLngBounds.contains(latLng)){
                self.setState({showBoundsErrMsg:true});
            }else{
                self.setState({showBoundsErrMsg:false});
                self.setState({latitude:latLng.lat,longitude:latLng.lng});

                map.clear();

                map.addPolygon({
                    'points': polygon_points,
                    'strokeColor' : 'red',
                    'strokeWidth': 2,
                    "fillColor":"rgba(255,0,0,0.2)",
                    'zIndex': 2
                    });

                map.addMarker({
                    position: latLng,
                    title: latLng,
                    animation: window.plugin.google.maps.Animation.DROP
                    });

                if(self.state.mapDeliveryImage){
                    map.addGroundOverlay({
                        'url': self.state.mapDeliveryImage,
                        'bounds': self.convertMapValues(self.props.selectedLocation.startPoint) || polygon_points,
                        'opacity': 1,
                        'clickable': false,
                        'bearing': self.props.selectedLocation.rotationAngle || 0,
                        'zIndex': 0
                        });
                }

            }

        });

          
 
    }

    closeMapHandler = () => {
        const map = this.getMap();
        map.remove();
        console.log("map removed");
    }

    confirmLocationHandler = (e,lat,lng) => {
        e.preventDefault();

        if(this.state.showBoundsErrMsg){
            return;
        }

        this.setState({mapLoading:true})
        const map = this.getMap();
        const self = this;
        const zoomLevel = JSON.parse(this.props.hcommerce_zoom_mapview).zoomLevel
        const mapView = JSON.parse(this.props.hcommerce_zoom_mapview).mapView
        const link = //`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
        `https://maps.google.com/?q=${lat},${lng}&ll=${lat},${lng}&z=${zoomLevel}&t=${mapView}`
        this.props.setCustomLocation(link);
        map.toDataURL({uncompress:true},(imageData) => {
            self.props.setMapSnapshot(imageData);
            // self.props.setMapSnapshot(this.imageBase);
            self.setState({goBack:true});
        });
        // this.takeScreenshotHandler();
    }

    componentWillUnmount() {
        $("body").attr('style', `background: ${this.props.menuColor.backgroundColor} !important`);
        $("body").css("color", this.props.menuColor.assetFontColor);
        $("html").css({"background": 'top center no-repeat', "background-color": this.props.menuColor.backgroundColor});
        $("#app-body").css("background", this.props.menuColor.backgroundColor);
        $("#root").css("background", this.props.menuColor.backgroundColor);
        $("#root").css("background-color", this.props.menuColor.backgroundColor);

        document.getElementById('app-body').classList.remove("_gmaps_cdv_");
        document.getElementsByTagName('html')[0].classList.remove("_gmaps_cdv_");
        
        console.log("Map component unmounting...")
        if(window.cordova)
            this.closeMapHandler();
       $('body').css("min-height",this.defaultMinHeight);
       $('body').css("transform","none")
    }

    componentDidUpdate(){
        customLocationColorConfig(this.props.menuColor);

        if(this.state.mapOpened && this.state.highAccuracyrequired) {
            this.fetchLocation(true, this.updateMapHandler);
            this.setState({highAccuracyrequired: false});
        }
        if(!this.state.crossClickable){
        setTimeout(() => {
            this.setState({crossClickable: true})
        }, 2000);}
    }

    componentDidMount(){
        // this.props.currentWidget({widgetType: true}); 
        $("body").attr('style', `background: transparent !important`);
        $("html").css({"background": "", "background-image": "", "background-color": ""});
        $("#app-body").attr('style', `background: transparent !important`);
        $("#root").attr('style', `background: transparent !important`);
        $("#root").css("background-color", "transparent !important");
        document.getElementById('app-body').classList.add("_gmaps_cdv_");

        this.defaultMinHeight = $('body').css("min-height");
        $('body').css("min-height","100vh");  
        this.fetchLocation(false, this.openMapsHandler);

        console.log("this.props.selectedLocation.mapDeliveryImage",this.props.selectedLocation)

        if(this.props.selectedLocation && this.props.selectedLocation.mapDeliveryImage){
            if(`${this.props.selectedLocation.mapDeliveryImage}`.startsWith('http://') ||
                `${this.props.selectedLocation.mapDeliveryImage}`.startsWith('https://')){
                    this.setState({mapDeliveryImage: this.props.selectedLocation.mapDeliveryImage})
            } else{
                this.setState({mapDeliveryImage: `${CMSPath_HTTP}${this.props.selectedLocation.mapDeliveryImage}`.split("../").join("")})
            }
        }

        let mapEventSent = localStorage.getItem("mapEventSent") == "true"
        if(!mapEventSent){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidgets.widgetType, 
                "MAP", 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), storeName: this.props.storeInfo.storeName, pageName: "MAP"},
                0, 
                this.props.guestIsLoggedIn,
                () => localStorage.setItem("mapEventSent", true)
            );
        }
    }

    render(){
        const { t } = this.props
        return(

            <section id="map-container" className="my-orders open" style = {{backgroundColor:"#fff"}}>
                <div className="orders-container" style={{height: !this.state.loadingError ? "90vh" : "25vh" ,maxHeight: "unset",bottom:"0"}}>
                    <div className="orders-heading">
                        <h5>{t('hcommerce.custom_location.header')}</h5>
                        {this.state.crossClickable && <Link exact to = "/hcommerce2" className="order-toggle">
                           <i onClick = {() => {
                               this.props.setSelectedLocation(null);
                               this.props.setCustomLocation(null);
                           }} className="fas fa-lg fa-times"></i>
                        </Link>}
                    </div>
                    
                        {!this.state.loadingError ? <form onSubmit = {(e) => {this.confirmLocationHandler(e,this.state.latitude,this.state.longitude)}}>
                            <div className="orders-body-container" style={{display: "block"}}>
                                <div className="orders-body" style={{ height: "75vh",maxHeight: "unset",minHeight: "unset"}}>
                                    <div className="form-row">
                                        {(this.state.mapLoading && !this.state.loadingError) && <p style = {{}}>{t('hcommerce.custom_location.fetching_location')}</p>}
                                        {this.state.mapOpened && !this.state.locationAttemptFailed && this.state.highAccuracyAttemptFailed && <p>{t('hcommerce.custom_location.detect_location_text1')}, <a style={{color: "blue"}} onClick={(e) => this.openSettings()}>{t('hcommerce.custom_location.detect_location_text2')}</a></p>}
                                        {this.state.showBoundsErrMsg ? <p style={{color:"red"}}>{t('hcommerce.custom_location.choose_location')}</p> : <br/>}
                                    </div>
                                    <div className="form-row">
                                        <p>{t('hcommerce.custom_location.to_change_location')}</p>
                                    </div>
                                    <div className="form-row" id = "maps_container" style={{border: "1px solid #ccc",height: "60vh"}}>
                                    </div>
                                </div>

                                <div className="controls">
                                    {!this.state.mapLoading ? <input type="submit" name="Set Location" value={t('hcommerce.custom_location.set_location')} disabled={this.state.mapLoading || this.state.showBoundsErrMsg} style = {{opacity: (this.state.mapLoading || this.state.showBoundsErrMsg) ? "0.3" : "1"}}/>
                                     : <input type="submit" disabled={true} name="Set Location" value={"Please wait..."} style = {{opacity: "0.8"}}/>}
                                </div>
                            </div> 
                        </form>
                        :<form onSubmit = {(e) => {
                            e.preventDefault();
                            this.setState({goBack:true});
                        }}>
                            <div className="orders-body-container" style={{display: "block"}}>
                                <div className="orders-body" style={{maxHeight: "unset",minHeight: "unset"}}>
                                    <div className="form-row">
                                        <p>{t('hcommerce.custom_location.unable_to_fetch_location')}</p>
                                        {this.state.locationAttemptFailed && !this.state.highAccuracyAttemptFailed && <p>{t('hcommerce.custom_location.to_detect_location')}, <a style={{color: "blue"}} onClick={(e) =>{ this.openSettings(); this.setState({goBack:true}) }}>{t('hcommerce.custom_location.enable_location')}</a></p>}
                                    </div>
                                </div>
                                <div className="controls">
                                    <input type="submit" name="Return to Check-out" value="Return to Check-out"/>
                                </div>
                            </div>
                           
                        </form>}
                    
                </div>
                {this.state.goBack ? <HashRouter>
                    <Redirect to={`/hcommerce2?mapOpened=${true}`}/>
                </HashRouter>: null} 

                {this.state.showMap && <HashRouter>
                    <Redirect exact to="/hcommerce2"/>
                </HashRouter>}
                
            </section>
            
        );
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        selectedLocation: state.store.Hcommerce.selectedLocation,
        hcommerce_zoom_mapview: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.HCOMMERCE_ZOOM_MAPVIEW
        ? state.store.home.clientConfig.extraConfigParam.HCOMMERCE_ZOOM_MAPVIEW : '{"zoomLevel" : "20", "mapView" : "k"}',
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        storeInfo: state.store.Hcommerce.storeInfo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
    }
}

export default connect(mapStateToProps,{ 
    currentWidget, 
    setCustomLocation, 
    setSelectedLocation,
    setMapSnapshot,
    popupOpenClose,
    sendAnalytics
 })(withTranslation('translations')(CustomLocation));